import '../scss/datepicker.scss';
import '@shoelace-style/shoelace/dist/components/input/input';

class Datepicker {
  constructor() {
    this.datepickers = document.querySelectorAll('.js-datepicker');
    this.syncDatepickerValue();

    this.syncDatepickerValue = this.syncDatepickerValue.bind(this);
    this.addEventListeners();
  }

  addEventListeners() {
    this.syncDatepickerValue();
  }

  syncDatepickerValue() {
    this.datepickers.forEach(slInput => {
      const hiddenInput = document.getElementById(slInput.id.replace('-shoelace', ''));
      if (hiddenInput) {
        slInput.addEventListener('sl-change', () => {
          hiddenInput.value = slInput.value;
        });
      }
    });
  }
}

export default new Datepicker();
